import { render } from "./Prediction.vue?vue&type=template&id=6778e591&scoped=true"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"

import "./Prediction.vue?vue&type=style&index=0&id=6778e591&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6778e591"

export default script